import Enemy, { randomInt } from "../enemy.js";
import { EnemyConfig, EnemyStateConfig } from "../../GameConfig/EnemyConfig.js";
import { Fly, Death } from "../states/index.js";
import DreadNoughtBurst from "../../Bursts/enemy/dreadnought-burst.js";
import Attack from "../states/Attack.js";

export default class DreadNought extends Enemy {
    constructor() {
        super();

        this.name = "DreadNought";

        this.states = [
            new Fly(
                this,
                EnemyConfig.DreadNought.IMG_SRC_FLY,
                EnemyConfig.DreadNought.MAX_FRAME_FLY,
            ),
            new Death(
                this,
                EnemyConfig.DreadNought.IMG_SRC_DEATH,
                EnemyConfig.DreadNought.MAX_FRAME_DEATH,
            ),
            new Attack(this),
        ];
        this.currentState = this.states[EnemyStateConfig.FLY];

        this.y = randomInt(
            EnemyConfig.DreadNought.MIN_Y_POS,
            EnemyConfig.DreadNought.MAX_Y_POS,
        );

        this.image.src = EnemyConfig.DreadNought.IMG_SRC_FLY;

        this.spriteWidth = EnemyConfig.DreadNought.SPRITE_WIDTH;
        this.spriteHeight = EnemyConfig.DreadNought.SPRITE_HEIGHT;

        this.speed = randomInt(
            EnemyConfig.DreadNought.MIN_SPEED,
            EnemyConfig.DreadNought.MAX_SPEED,
        );

        this.health = EnemyConfig.DreadNought.HEALTH;
        this.score = EnemyConfig.DreadNought.ENEMY_SCORE;
        this.damage = EnemyConfig.DreadNought.ENEMY_DAMAGE;

        this.burst = new DreadNoughtBurst();

        this.canAttack = true;

        this.attackTimer = EnemyConfig.DreadNought.ATTACK_TIMER;
        this.attackInterval = randomInt(
            EnemyConfig.DreadNought.ATTACK_INTERVAL_MIN,
            EnemyConfig.DreadNought.ATTACK_INTERVAL_MAX,
        );

        this.weapons = EnemyConfig.DreadNought.WEAPONS;

        this.rarity = EnemyConfig.DreadNought.RARITY;
    }
}
